import { render } from "./HeroiconsSolidMailOpen.vue?vue&type=template&id=2260e15f"
const script = {}

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidMailOpen.vue"]])

export default __exports__